import { useState, useEffect } from "react";
import { API, authFetch } from "@/App";

export function useDashboardState() {
  // Email input
  const [emailContent, setEmailContent] = useState("");

  // Extraction results
  const [extractedData, setExtractedData] = useState(null);
  const [extractionInfo, setExtractionInfo] = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [isExtracting, setIsExtracting] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState(null);

  // Collected emails
  const [collectedEmails, setCollectedEmails] = useState([]);

  // Validation modal
  const [validationModal, setValidationModal] = useState({
    open: false,
    mode: "extraction",
    extractedData: {},
    existingData: {},
    emailContent: "",
  });
  const [isSavingValidation, setIsSavingValidation] = useState(false);

  // Conflicts modal (legacy)
  const [conflictsModal, setConflictsModal] = useState({ open: false, conflicts: {}, resolved: {} });
  const [customConflictValue, setCustomConflictValue] = useState({});

  // Enrich modal
  const [isEnrichModalOpen, setIsEnrichModalOpen] = useState(false);
  const [enrichEmailContent, setEnrichEmailContent] = useState("");
  const [isEnriching, setIsEnriching] = useState(false);

  // Column template
  const [columnTemplate, setColumnTemplate] = useState(null);

  // Company profiles
  const [companyProfiles, setCompanyProfiles] = useState([]);
  const [selectedProfileId, setSelectedProfileId] = useState("");
  const [detectedCompany, setDetectedCompany] = useState(null);

  // Fetch column template and company profiles on mount
  useEffect(() => {
    const fetchColumns = async () => {
      try {
        const response = await authFetch(`${API}/columns`, {});
        if (response.ok) {
          const data = await response.json();
          setColumnTemplate(data);
        }
      } catch (error) {
        console.error("Failed to fetch columns:", error);
      }
    };

    const fetchProfiles = async () => {
      try {
        const response = await authFetch(`${API}/company-profiles`, {});
        if (response.ok) {
          const data = await response.json();
          const profiles = data.profiles || [];
          setCompanyProfiles(profiles);
          const defaultProfile = profiles.find(p => p.name.includes("Stores") && p.name.includes("Pergolas"));
          if (defaultProfile) {
            setSelectedProfileId(defaultProfile.profile_id);
          }
        }
      } catch (error) {
        console.error("Failed to fetch profiles:", error);
      }
    };

    fetchColumns();
    fetchProfiles();
  }, []);

  return {
    emailContent, setEmailContent,
    extractedData, setExtractedData,
    extractionInfo, setExtractionInfo,
    currentOrderId, setCurrentOrderId,
    isExtracting, setIsExtracting,
    isExporting, setIsExporting,
    isEditing, setIsEditing,
    editedData, setEditedData,
    collectedEmails, setCollectedEmails,
    validationModal, setValidationModal,
    isSavingValidation, setIsSavingValidation,
    conflictsModal, setConflictsModal,
    customConflictValue, setCustomConflictValue,
    isEnrichModalOpen, setIsEnrichModalOpen,
    enrichEmailContent, setEnrichEmailContent,
    isEnriching, setIsEnriching,
    columnTemplate,
    companyProfiles, selectedProfileId, setSelectedProfileId,
    detectedCompany, setDetectedCompany,
  };
}
